// Login.js
import React from 'react';
import LoginForm from '../sections/login/LoginForm';
import '../../styles/pages/Login.css';

function Login() {
  return (
    <div >
      <h1 className="Login-title">Login</h1>
      <LoginForm />
    </div>
  );
}

export default Login;
